const stripHtmlSuffix = (value: string): string =>
    value.replace(/\.html$/i, '')

const ensureHtmlSuffix = (value: string): string =>
    value.toLowerCase().endsWith('.html') ? value : `${value}.html`

const stripHost = (value: string): string =>
    value
        .replace(/^(?:https?:)?\/\/[^/]+/i, '')
        .replace(/^[a-z0-9.-]+\.[a-z]{2,}(?=\/|$)/i, '')

export const toPdpHref = (urlKeyOrUrl?: string | null): string => {
    if (!urlKeyOrUrl?.trim()) return ''
    const trimmed = urlKeyOrUrl.trim()
    if (
        trimmed.startsWith('http') ||
        trimmed.startsWith('//') ||
        trimmed.startsWith('/') ||
        /^[a-z0-9.-]+\.[a-z]{2,}\//i.test(trimmed)
    ) {
        return pdpHrefFromCanonical(trimmed)
    }
    return `/producto/${ensureHtmlSuffix(stripHtmlSuffix(trimmed))}`
}

export const pdpHrefFromCanonical = (canonicalUrl?: string | null): string => {
    if (!canonicalUrl?.trim()) return ''
    const path = stripHost(canonicalUrl.trim())
        .replace(/^\//, '')
        .replace(/\/$/, '')
    if (!path) return ''
    const withHtml = ensureHtmlSuffix(path)
    if (withHtml.toLowerCase().startsWith('producto/')) {
        return `/${withHtml}`
    }
    return `/producto/${withHtml}`
}
